// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { xBaseTheme } from "@eisinc/XDL/types";
import { color, styledScrollbar, xScreen } from "@eisinc/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import X from "@insite/mobius/Icons/X";
import ModalPresentationPropsDefault from "@insite/mobius/Modal/presentationProps";
import { getProp } from "@insite/mobius/utilities";
import { css } from "styled-components";

export default {
    sizeVariants: {
        small: 430,
        medium: 800,
        large: 1110,
    },
    defaultProps: {
        ...ModalPresentationPropsDefault,
        mergeCss: true,
        cssOverrides: {
            headlineTypography: css`
                margin-bottom: 0;
                letter-spacing: 0;
            `,
            modalTitle: css`
                position: relative;
                padding: 16px 16px 13px;
                border-bottom: 0;
                &:after {
                    content: "";
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    width: calc(100% - 32px);
                    height: 1px;
                    background-color: ${color("common.border")};
                    margin: 0 auto;
                }
            `,
            modalContent: css`
                padding: 12px 16px 16px;
                ${styledScrollbar()}
            `,
            modalBody: css`
                border-radius: 0;
                background-color: ${color("common.white")};
                box-shadow: none;
                overflow: hidden;
                ${xScreen("lte", "md")} {
                    height: auto;
                    max-height: calc(100% - 90px);
                    margin: 45px;
                }
                ${xScreen("lt", "sm")} {
                    max-height: calc(100% - 30px);
                    margin: 16px;
                }
            `,
        },
        headlineTypographyProps: {
            size: 24,
            lineHeight: "29px",
            weight: fontConfig.weight.medium,
            color: "common.ui6",
        },
        closeButtonProps: {
            mergeCss: true,
            variant: "link" as any,
            css: css`
                width: 24px;
                height: 24px;
                & > ${IconWrapper} {
                    color: ${color("common.ui5")};
                }
                &:not(:disabled):hover,
                &:not(:disabled):focus {
                    > ${IconWrapper} {
                        color: ${color("common.ui6")};
                    }
                }
            `,
        },
        closeButtonIconProps: {
            mergeCss: true,
            src: X,
            color: "common.ui6",
            size: 24,
            css: css`
                transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            `,
        },
    },
} as xBaseTheme["modal"];
